import { useState } from 'react';
import Question from './Question';

const Test = ({ status, onResponse, selected, index, length, test, setTest, count, onReset, onPrev, onNext }) => {
  const [visible, setVisible] = useState(false);

  const onOpen = () => {
    setVisible(true);
    setTimeout(() => {
      const modal = document.getElementById('Modal');
      modal.addEventListener('click', onClick);
      document.addEventListener('keyup', onEscape);
    });
  };

  const onClose = () => {
    setVisible(false);
    setTimeout(() => {
      document.removeEventListener('keyup', onEscape);
    });
  };

  const onClick = (e) => {
    if (e.target.id === 'Modal') {
      onClose();
    }
  };

  const onEscape = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <>
      {test &&
        <button style={{ marginRight: 10 }} onClick={onReset}>
          Reset
        </button>
      }
      <div style={{ marginRight: 10 }}>{count}</div>
      <button className="Test" onClick={onOpen}>
        Test
      </button>
      {visible &&
        <div id="Modal" className="Modal TestModal">
          {test && index > 0 &&
            <button className="Prev" onClick={onPrev}>
              {'<'}
            </button>
          }
          <div className="ModalCard">
            {test ?
              <>
                <div className={`Title ${status ? 'Correct' : status === false ? 'Incorrect' : ''}`}>
                  {selected.title}
                  <button onClick={onClose}>
                    Close
                  </button>
                </div>
                <div className="Body">
                  <Question data={selected} onResponse={onResponse} />
                </div>
              </>
              :
              <button className="StartTest" onClick={() => setTest(true)}>
                Start Test
              </button>
            }
          </div>
          {test && index < length - 1 &&
            <button className="Next" onClick={onNext}>
              {'>'}
            </button>
          }
        </div>
      }
    </>
  );
};

export default Test;